module.exports = __webpack_public_path__ + "static/media/aml-logo-orange.d3c2803d.svg";